(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baz-v4-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('baz-campaign-countdown')) {
  customElements.define('baz-campaign-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.values = this.querySelector('[data-countdown-values]');
      this.ended = this.querySelector('[data-countdown-ended]');
      this.numbers = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-unit="' + unit + '"]'));
      const value = this.dataset.end || '';
      this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      if (!Number.isFinite(this.deadline) || !this.values || !this.ended || this.numbers.some(node => !node)) {
        if (this.values) this.values.hidden = true;
        return;
      }
      this.resume = () => {
        window.clearInterval(this.timer);
        const active = this.update();
        if (active && !document.hidden) this.timer = window.setInterval(() => this.update(), 1000);
      };
      document.addEventListener('visibilitychange', this.resume);
      this.resume();
    }
    update() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const parts = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      this.numbers.forEach((node, index) => {
        const value = String(parts[index]).padStart(2, '0');
        if (node.textContent !== value) node.textContent = value;
      });
      this.values.hidden = seconds === 0;
      this.ended.hidden = seconds !== 0;
      if (seconds === 0) this.stop();
      return seconds > 0;
    }
    stop() {
      window.clearInterval(this.timer);
      if (this.resume) document.removeEventListener('visibilitychange', this.resume);
    }
    disconnectedCallback() { this.stop(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
